function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganisationNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.449,2.514l0,11.667c0,1.571 0,2.357 0.488,2.845c0.489,0.488 1.274,0.488 2.846,0.488l11.666,0m-12.083,-3.333l0.415,-1.108c0.241,-0.641 0.361,-0.962 0.544,-1.106c0.242,-0.191 0.569,-0.232 0.851,-0.108c0.214,0.094 0.41,0.375 0.803,0.936c0.44,0.629 0.66,0.943 0.887,1.036c0.299,0.122 0.642,0.06 0.88,-0.159c0.18,-0.165 0.277,-0.537 0.47,-1.279l1.037,-3.973c0.219,-0.842 0.329,-1.263 0.527,-1.433c0.25,-0.216 0.604,-0.263 0.903,-0.12c0.234,0.112 0.45,0.49 0.882,1.246c0.496,0.869 0.745,1.303 0.994,1.414c0.316,0.141 0.687,0.071 0.931,-0.174c0.192,-0.194 0.266,-0.689 0.414,-1.678l0.712,-4.744",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#9a9a9a",
      strokeWidth: "1.5px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganisationNormal);
export default __webpack_public_path__ + "static/media/organisation_normal.690bc65fbea8d393fc057dd355a7a6b0.svg";
export { ForwardRef as ReactComponent };